import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import WhyChooseSection from "./components/WhyChooseSection";
import IndustriesSection from "./components/IndustriesSection";
import DealerSection from "./components/DealerSection";
import CatalogSection from "./components/CatalogSection";
import ContactSection from "./components/ContactSection";
import MadeInIndiaSection from "./components/MadeInIndiaSection";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

// Admin Components
import AdminLogin from "./components/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./components/admin/AdminDashboard";
import ProductsManagement from "./components/admin/ProductsManagement";
import ContactsManagement from "./components/admin/ContactsManagement";
import AdminSettings from "./components/admin/AdminSettings";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MadeInIndiaSection />
        <ProductsSection />
        <WhyChooseSection />
        <IndustriesSection />
        <DealerSection />
        <CatalogSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-right" />
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="products" element={<ProductsManagement />} />
          <Route path="contacts" element={<ContactsManagement />} />
          <Route path="dealers" element={<ContactsManagement />} />
          <Route path="catalog" element={<div className="text-center py-12 text-zinc-600">Catalog upload coming soon...</div>} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
